const getOrFilterGroup = filterGroup => filterGroup.operator === 'OR' ? filterGroup : filterGroup.values[0];
const getOrFilterGroups = filterGroups => filterGroups.filter(filterGroup => filterGroup.type === 'BOOLEAN').map(getOrFilterGroup);
const isUrlFilter = filter => filter.type === 'URL' || filter.type === 'QUERY_PARAM';
const getFlatFilters = filterConfiguration => getOrFilterGroups(filterConfiguration.values).flatMap(filterGroup => filterGroup.values);
export const isShowEverywhere = ({
  filter: filterConfiguration
}) => {
  const urlFilters = getFlatFilters(filterConfiguration).filter(isUrlFilter);
  return urlFilters.length === 0 || urlFilters.every(urlFilter => urlFilter.operator === 'EQ_IGNORING_COMPARISON');
};
export const isShowToEveryone = ({
  filter: filterConfiguration
}) => {
  const visitorFilters = getFlatFilters(filterConfiguration).filter(filter => !isUrlFilter(filter));
  return visitorFilters.length === 0;
};
const isSavedAudienceFilter = filter => filter.type === 'SAVED_AUDIENCE';
export const findSavedAudienceFilter = ({
  filter: filterConfiguration
}) => filterConfiguration.values.find(isSavedAudienceFilter);